<template>
  <div style="max-width: 180px;" class="ml-3">
    <v-text-field
      dense
      :placeholder="`Search ${$appName}`"
      hide-details
      solo
      clearable
      v-model="search"
      autocomplete="off"
      @keydown.enter="performSearch"
    ></v-text-field>

    <v-dialog
      v-model="dialog"
      :fullscreen="isMobile"
      width="900"
    >
      <v-toolbar dense>
        "<strong>{{ search }}</strong>"
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false;" icon small>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="mx-auto" >
        <v-card-text>
          <v-list>
            <template v-if="loading">
              <div class="text-center my-3">
                <v-progress-circular
                  indeterminate
                  :size="50"
                  color="primary"
                ></v-progress-circular>
              </div>
            </template>
            <template v-else-if="broadcasts.length > 0">
              <div
                v-for="broadcast in broadcasts"
                :key="broadcast.id"
              >
                <v-list-item
                  @click.native="$gtag.clickLink(broadcast.title); goToStreamPage(broadcast);"
                  class="clickable"
                >
                  <v-list-item-content>
                    <div>
                      {{ broadcast.title }}
                    </div>
                    <div class="mt-1">
                      <template v-if="broadcast.stage === 'live'">
                        <v-chip small color="error" outlined>Live Now</v-chip>
                      </template>
                      <template v-else-if="broadcast.stage === 'scheduled'">
                        <v-chip small class="mr-2">Scheduled</v-chip>
                        <strong>{{ broadcast.weekday }} @ {{ broadcast.start_time_formatted }}</strong>
                      </template>
                    </div>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon>mdi-play-box-outline</v-icon>
                  </v-list-item-icon>
                </v-list-item>
                <v-divider></v-divider>
              </div>
            </template>
            <template v-else>
              <v-list-item>
                <v-list-item-content>Nothing found.</v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :to="'/broadcasts'"
            @click.native="clear(); $gtag.clickButton('See More Broadcasts')"
          >
            See All
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import seoNameMixin from '../mixins/seoNameMixin';
export default {
  mixins: [seoNameMixin],
  data() {
    return {
      search: null,
      loading: false,
      broadcasts: [],
      dialog: false,
    }
  },
  computed: {
    ...mapState(['categories', 'window']),
    ...mapGetters(['isMobile']),
    fullscreen() {
      return this.isMobile;
    }
  },
  methods: {
    performSearch() {
      this.dialog = true;
      this.loading = true;
      axios
        .get('getBroadcasts', {
          params: {
            count: 15,
            sort: 'date_formatted',
            descending: true,
            search: this.search,
            page: 1,
          },
        })
        .then(res => {
          this.broadcasts = res.data.data
          this.loading = false;
        });
    },
    goToStreamPage(broadcast) {
      this.$router.push({ name: 'Stream', params: { id: broadcast.id, seoName: this.seoName(broadcast.title) } });
      this.clear();
    },
    clear() {
      this.dialog = false;
      this.broadcasts = [];
      this.search = null;
    }
  }
}
</script>
<style scoped>
.headline {
  word-break: normal!important;
  display: block;
}
.clickable {
  cursor: pointer;
}
</style>
